import { Button } from '@creditornot/cb-button';
import { Modal, ModalContent, ModalFooter, ModalHeader } from '@creditornot/cbt-modal';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Typography } from 'common/typography';

type Props = { isOpen: boolean; onClose: () => void };

const ModalButtons = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 16px;
  width: 100%;
`;

export const EmptyToDeleteSharedMenuModal = ({ isOpen, onClose }: Props) => (
  <Modal open={isOpen} onDismiss={onClose} sizePreset={'centered:medium'} disableContentPadding>
    <ModalHeader onCloseClick={onClose}>
      <FormattedMessage id="shared-menu.editor.delete.modal.title.venues-linked" />
    </ModalHeader>
    <ModalContent>
      <Typography.Body3>
        <FormattedMessage id="shared-menu.editor.delete.modal.description.venues-linked" />
      </Typography.Body3>
    </ModalContent>
    <ModalFooter>
      <ModalButtons>
        <Button size="small" onClick={onClose} variant="secondary">
          <FormattedMessage id="shared-menu.editor.delete.modal.button.got-it" />
        </Button>
      </ModalButtons>
    </ModalFooter>
  </Modal>
);
